import { cloneDeep } from '@/utils';
import { proxy } from '@umijs/max';
import { DepartmentType, UserType } from '../MemberSelectModal/interface';

interface Store {
  loading: boolean;
  curSearchValue: string;
  curDepartmentId: null | string;
  memberSelectModalVisible: boolean;
  departmentList: DepartmentType[];
  userList: UserType[];
}

const initialState: Store = {
  loading: false,
  curSearchValue: '',
  curDepartmentId: null,
  memberSelectModalVisible: false,
  userList: [],
  departmentList: [],
};

export const store = proxy<Store>(initialState);

export const resetStore = () => {
  const resetObj = cloneDeep(initialState);
  Object.keys(resetObj).forEach((key) => {
    // @ts-ignore
    store[key] = resetObj[key];
  });
};
